import React, { useState, useRef } from 'react';
import {
  focusEditor,
  useEventPlateId,
  usePlateEditorState,
  isCollapsed,
  someNode,
  setAlign,
  KEY_ALIGN,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ToolbarDropdown, { ToolbarDropdownButton } from './ToolbarDropdown';

export const AlignmentDropdown = ({ id, ...rest }) => {

  const [open, setOpen] = useState(false);
  const ref = useRef();

  const editor = usePlateEditorState(useEventPlateId(id));

  const active = () => {
    if (isCollapsed(editor?.selection)) {
      if (someNode(editor, { match: { [KEY_ALIGN]: 'left' } })) return 'left';
      if (someNode(editor, { match: { [KEY_ALIGN]: 'right' } })) return 'right';
      if (someNode(editor, { match: { [KEY_ALIGN]: 'center' } })) return 'center';
      if (someNode(editor, { match: { [KEY_ALIGN]: 'justify' } })) return 'justify';
    }
    return 'left';
  };

  const show = () => {
    setOpen(true);
  };

  const dismiss = () => {
    setOpen(false);
  };

  const setEditorAlignment = (e, value) => {
    e.stopPropagation();
    e.preventDefault();

    setAlign(editor, { value, key: KEY_ALIGN });
    focusEditor(editor);
    dismiss();
  };
  const icons = {
    'left': 'align-left',
    'center': 'align-center',
    'right': 'align-right',
    'justify': 'align-justify',
  };

  const trigger = (
    <ToolbarDropdownButton
      className="button--unstyled toolbar-dropdown__button toolbar-dropdown__button--icon"
      showIcon
    >
      <FontAwesomeIcon
        icon={['fal', icons[active()]]}
      />
    </ToolbarDropdownButton>
  );

  return (
    <div
      ref={ref}
      className="plate-dropdown-button-combo plate-dropdown-button-combo--alignment"
    >
      <ToolbarDropdown
        {...rest}
        isOpen={open}
        show={show}
        dismiss={dismiss}
        DropdownButton={trigger}
        name="list-dropdown"
        className="plate-toolbar__dropdown-button"
        root={null}
      >
        <button
          className="button--unstyled button--editor-menu"
          onClick={(e) => setEditorAlignment(e, 'left')}
          onMouseDown={(e) => e.preventDefault()}
        >
          <FontAwesomeIcon
            icon={['fal', 'align-left']}
          />
        </button>
        <button
          className="button--unstyled button--editor-menu"
          onClick={(e) => setEditorAlignment(e, 'center')}
          onMouseDown={(e) => e.preventDefault()}
        >
          <FontAwesomeIcon
            icon={['fal', 'align-center']}
          />
        </button>
        <button
          className="button--unstyled button--editor-menu"
          onClick={(e) => setEditorAlignment(e, 'right')}
          onMouseDown={(e) => e.preventDefault()}
        >
          <FontAwesomeIcon
            icon={['fal', 'align-right']}
          />
        </button>
        <button
          className="button--unstyled button--editor-menu"
          onClick={(e) => setEditorAlignment(e, 'justify')}
          onMouseDown={(e) => e.preventDefault()}
        >
          <FontAwesomeIcon
            icon={['fal', 'align-justify']}
          />
        </button>
      </ToolbarDropdown>
    </div>

  );
};
